<template>
    <div class="coming-soon">
      <div class="content">
        <h1>Coming Soon</h1>
        <p>We're working hard to bring you something amazing! Stay tuned.</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "coming-soon",
  };
  </script>
  
  <style scoped>
  .coming-soon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f5f5f5;
    color: #333;
    text-align: center;
  }
  
  .content {
    max-width: 500px;
    margin: auto;
  }
  
  h1 {
    font-size: 3rem;
    margin-bottom: 1rem;
  }
  
  p {
    font-size: 1.2rem;
  }
  </style>
  